import axios from 'axios';

// let url = process.env.REACT_APP_VERCEL_ENV === "production" ? 'https://admin.24task.com/' : `https://shovocqdyj.execute-api.us-east-2.amazonaws.com/dev/`
// used 
let url = process.env.REACT_APP_VERCEL_ENV === "production" ? 'https://u06cg2hla2.execute-api.us-east-2.amazonaws.com/' : `https://682cmrp6o5.execute-api.us-east-2.amazonaws.com/`
// let url ='https://oq192vl3uf.execute-api.us-east-2.amazonaws.com/'

let nft_url = "https://fs6jtboen7.execute-api.us-east-2.amazonaws.com/dev/";

// api calling function
export const apiHalper = (api, method, data, headers) => {
    const apiUrl = url + api;
    return new Promise((resolve, reject) => {
        axios({
            method: method,
            data: data,
            url: apiUrl,
            headers: headers
        })
            .then(res => resolve(res))
            .catch(error => reject(error));
    });
}

export const apiHelperNFT = (api, method, data, headers) => {
    const apiUrl = nft_url + api;
    return new Promise((resolve, reject) => {
        axios({
            method: method,
            data: data,
            url: apiUrl,
            headers: headers
        })
            .then(res => resolve(res))
            .catch(error => reject(error));
    });
}


export const apiDeviceHelper = (api, method, data, headers) => {
    const apiUrl2 = 'https://adminapi.24task.com/' + api;
    return new Promise((resolve, reject) => {
        axios({
            method: method,
            url: apiUrl2,
            data: data,
            headers: headers
        })
            .then(res => resolve(res))
            .catch(error => reject(error));
    });
}